import { Card, Text } from '@billda/design-system';
import { format, parseISO } from 'date-fns';
import { LabelValueRow } from '../LabelValueRow';
import type { PotApprovals } from '../../types/potDetails.types';

interface PotTimelineCardProps {
  approvals: PotApprovals;
}

export function PotTimelineCard({ approvals }: PotTimelineCardProps) {
  const formatDateTime = (dateString: string) =>
    format(parseISO(dateString), 'dd MMM yyyy, HH:mm');

  const hasTimeline =
    approvals.submittedAt || approvals.approvedAt || approvals.rejectedAt;

  if (!hasTimeline) return null;

  return (
    <Card data-testid="pot-timeline-card" className="p-4 sm:p-6">
      <Text variant="h6" className="mb-4">
        Activity
      </Text>
      <div className="flex flex-col gap-1">
        {approvals.submittedAt && approvals.submittedByName && (
          <LabelValueRow
            label="Submitted"
            value={
              <Text variant="body2" color="secondary">
                {formatDateTime(approvals.submittedAt)} by{' '}
                {approvals.submittedByName}
              </Text>
            }
          />
        )}
        {approvals.approvedAt && approvals.approvedByName && (
          <LabelValueRow
            label="Approved"
            value={
              <Text variant="body2" className="text-content-success">
                {formatDateTime(approvals.approvedAt)} by{' '}
                {approvals.approvedByName}
              </Text>
            }
          />
        )}
        {approvals.rejectedAt && approvals.rejectedByName && (
          <LabelValueRow
            label="Rejected"
            value={
              <Text variant="body2" className="text-content-error">
                {formatDateTime(approvals.rejectedAt)} by{' '}
                {approvals.rejectedByName}
              </Text>
            }
          />
        )}
      </div>
    </Card>
  );
}
